<template>
  <div>
    <!-- SCRIPT : It's a script input.-->
    <label class="control-label">{{ labelText }}</label>
    <p v-if="piece.options.instructions" v-html="piece.options.instructions" class="piece-instructions"></p>
    <input
      :id="inputId"
      type="hidden"
      :class="'form-control ' + piece.name"
      :name="inputName"
      :value="cleanedPieceContent"
    />
    <div :id="editorId" class="w-100 piece-script-editor"></div>
    <div class="step-spacer"></div>
  </div>
</template>

<script>
import utils from '../../../../mixins/utils';

export default {
  name: 'script-piece',
  mixins: [utils],
  props: {
    pieceIndex: {
      type: Number,
      required: true,
    },
    piece: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cleanedPieceContent() {
      return this.stripSlashes(this.piece.content);
    },
    editorId() {
      return 'code-editor-' + this.piece.id;
    },
    inputElement() {
      return document.querySelector(`input#${this.inputId}`);
    },
    inputId() {
      return `piece-input-${this.piece.id}`;
    },
    inputName() {
      return `pieces[${this.pieceIndex}][content]`;
    },
    labelText() {
      switch (this.piece.name) {
        case 'custom_scripts_head':
          return 'Custom HTML header';
        case 'custom_scripts_footer':
          return 'Custom HTML footer';
        default:
          return this.piece.name;
      }
    },
  },
  mounted() {
    const editor = new CodeFlask(`#${this.editorId}`, {
      language: 'html',
      lineNumbers: false,
    });
    editor.updateCode(this.cleanedPieceContent);
    editor.onUpdate(code => (this.inputElement.value = code));
  },
};
</script>

<style lang="scss">
.piece-script-editor {
  min-height: 300px;
  position: relative;

  pre {
    background: none;
    border: 0;
  }

  textarea {
    border: 1px solid #cccccc;
  }
}
</style>
